// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footnote[data-v-7f892821] {\n  width: 300px;\n}", ""]);
// Exports
module.exports = exports;
